import './loading.scss';

import { LoadingLogo } from '@spo/storybook';
import { VtmnProgressbar } from '@vtmn/react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type LoadingProps = {
  loadingLabel?: string;
  isMassEdit?: boolean;
};

export const Loading = ({ loadingLabel, isMassEdit = false }: LoadingProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={clsx(['loading-container', { 'mass-edit': isMassEdit }])}
      data-testid="loading-component"
    >
      <div className="loading-logo-container">
        <LoadingLogo />
      </div>
      <p className="loading-label">{loadingLabel || t('loading_screen')}</p>
      <VtmnProgressbar
        className="vtmn-mx-auto vtmn-mt-4"
        status="indeterminate"
        aria-label="Loading bar"
      />
    </div>
  );
};
